import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface FloatingDecorProps {
  Icon: BoxIcon;
  className?: string;
  delay?: number;
  duration?: number;
  yOffset?: number;
  size?: number;
  color?: string;
}
export function FloatingDecor({
  Icon,
  className = '',
  delay = 0,
  duration = 4,
  yOffset = 15,
  size = 24,
  color = 'currentColor'
}: FloatingDecorProps) {
  return <motion.div className={`absolute pointer-events-none opacity-60 ${className}`} animate={{
    y: [0, -yOffset, 0],
    rotate: [-5, 5, -5]
  }} transition={{
    duration: duration,
    repeat: Infinity,
    ease: 'easeInOut',
    delay: delay
  }} data-id="element-126">
      <Icon size={size} color={color} strokeWidth={1.5} data-id="element-127" />
    </motion.div>;
}